import { getApiBaseUrl } from "./apiBase";

const BASE = getApiBaseUrl();
async function req(method, path, body=null) {
  const token = localStorage.getItem("accessToken");
  const opts = { method, headers:{"Content-Type":"application/json"} };
  if (token) opts.headers["Authorization"] = `Bearer ${token}`;
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(`${BASE}${path}`, opts);
  let json = {};
  try { json = await res.json(); } catch {}
  if (!res.ok) {
    const e = new Error(json.message || "Erro");
    e.status = res.status;
    e.code = json.code;
    e.retryAfter = Number(res.headers.get("Retry-After")) || json.retryAfter || 0;
    throw e;
  }
  return json;
}
const svc = {
  login:         (email,senha,lembrar=false) => req("POST","/auth/login",{email,senha,lembrar}),
  refresh:       (refreshToken) => req("POST","/auth/refresh",{refreshToken}),
  logout:        () => req("POST","/auth/logout"),
  me:            () => req("GET","/auth/me"),
  esqueciSenha:  (email) => req("POST","/auth/esqueci-senha",{email}),
  resetSenha:    (token,novaSenha) => req("POST","/auth/reset-senha",{token,novaSenha}),
  trocarSenha:   (data)             => req("POST","/usuarios/trocar-senha",data),
  onboardingStatus: () => req("GET","/auth/onboarding-status"),

  // Sessões ativas
  listarSessoes:        () => req("GET",  "/auth/sessoes"),
  revogarSessao:        (jti) => req("DELETE", `/auth/sessoes/${encodeURIComponent(jti)}`),
  encerrarOutrasSessoes:() => req("POST", "/auth/sessoes/encerrar-outras"),
};
export default svc;
